import { render } from "./LeadDetails.vue?vue&type=template&id=bfba34d0"
import script from "./LeadDetails.vue?vue&type=script&lang=js"
export * from "./LeadDetails.vue?vue&type=script&lang=js"
script.render = render

export default script